$(document).ready(function() {
  // Validation for payment terms agreement checkbox
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      } else {
        $('#error-for-agree').addClass('show-error');
        $('#error-for-agree').removeClass('hidden');
        $('.label-agree').css('color', '#DD1D1D');
        return false;
      }
  });
});